<!--物流信息-->
<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               :title="type" size="70%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="detail-wrap">
        <el-form ref="editForm" :model="formData">
<!--          <div class="d-header">-->
<!--            <div class="fl">-->
<!--              <i class="el-icon-info"/>-->
<!--              交货单号：<span v-if="formData.collectNo"-->
<!--                             style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.collectNo }}</span>-->
<!--              <span v-else class="information">待生成</span>-->

<!--              &lt;!&ndash; 状态 &ndash;&gt;-->
<!--              <span v-if="formData.stat==1" class="information">待发货</span>-->
<!--              <span v-if="formData.stat==3" class="information">已发货</span>-->
<!--              <span v-if="formData.stat==99" class="information">取消</span>-->


<!--            </div>-->
<!--            <div class="fr">-->

<!--            </div>-->
<!--          </div>-->

          <div>

            <!-- 基本信息 -->
            <dix style="display: flex;  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
              <div class="d-cont edit-mce-box" style="width: 98%;">
                <div class="d-item">
                  <div class="title first"><b>主信息</b></div>
                  <table class="table-detail">
                    <tbody>
                    <tr>
                      <th>
                        物流单号
                      </th>
                      <td>
                        {{ formData.num }}
                      </td>

                      <th>
                        状态
                      </th>
                      <td v-if="formData.state==1">揽收</td>
                      <td v-else-if="formData.state==0">在途</td>
                      <td v-else-if="formData.state==5">派件</td>
                      <td v-else-if="formData.state==3">签收</td>
                      <td v-else-if="formData.state==6">退回</td>
                      <td v-else-if="formData.state==4">退签</td>
                      <td v-else-if="formData.state==7">转投</td>
                      <td v-else-if="formData.state==2">疑难</td>
                      <td v-else-if="formData.state==8">清关</td>
                      <td v-else-if="formData.state==14">拒签</td>
                      <td v-else></td>

<!--                      <th>-->
<!--                        交货人名称-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        {{ formData.collecter }}-->
<!--                      </td>-->
                    </tr>

                    </tbody>
                  </table>
                </div>

                <div class="d-item">
                  <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
                    <div class="title first"><b>物流轨迹</b></div>
                    <div class="item-button" style="margin-top: 8px;"></div>
                  </div>
                  <div>
                    <vxe-table
                      style="margin-top: 0px;"
                      :stripe="true"
                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                      :row-config="{height: 30,isHover: true,padding: 0,}"
                      :row-style="{ fontSize: '12px',  }"
                      show-overflow
                      height="380"
                      :column-config="{ resizable: true }"
                      :data="formData.list">
                      <vxe-column field="time" title="时间" width="100"></vxe-column>
                      <vxe-column field="content" title="内容"></vxe-column>
                    </vxe-table>
                  </div>
                </div>
              </div>
            </dix>
          </div>
        </el-form>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import CollectInfo from "@/views/accessories/applyFor/apply/collectInfo.vue";

export default {
  name: 'logisticsInformationInfoDialog',
  components: {CollectInfo},
  props: ['multi', 'formData'],
  created() {

  },
  mounted() {
    // this.getData()
  },
  data() {
    return {
      drawer: true,
    }
  },
  methods: {
    // getData() {
    //   if (this.dataId && !isNaN(this.dataId)) {
    //     this.$http.post(api.spPartsApplyCollectHeader.getDataUrl, {id: this.dataId}).then(response => {
    //       this.formData = response.data.data
    //     })
    //   }
    // },

    close() {
      // this.$mask.open()
      // this.$http({
      //   url: api.spPartsApplyHeader.commitUrl,
      //   method: 'post',
      //   data: this.formData
      // }).then(res => {
      //   this.$mask.close()
      //   this.$message.success('操作成功')
      //   this.visiable = false
      //   this.$emit('update:visiable', this.visiable)
      //   this.$emit('goBackIndex')
      // }).catch(() => {
      //   this.$mask.close()
      // })
    },

    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    },
    handleClose() {
      this.cancelForm()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
